// extracted by mini-css-extract-plugin
export var banner = "_l7-0";
export var settingRow = "_l7-2";
export var titleIcon = "_l7-1";